<template>
  <div>
    <v-flex v-if="simc && showSelect" xs12 pr-2>
      <v-autocomplete
        clearable
        hide-no-data
        v-model="selectedUlic"
        placeholder="Wpisz nazwę ulicy"
        item-text="nameFull"
        item-value="symbol"
        :items="streets"
        :search-input.sync="search"
      >
        <div slot="label">Ulica<span v-if="model.ulic.$schema.fieldRequired"> *</span></div>
        <template v-slot:append-outer>
          <v-btn bottom large flat color="success" @click="saveUlic">Dodaj</v-btn>
        </template>
      </v-autocomplete>

      <p class="autocomplete-warning">
        {{ error }}
        <slot name="errors"></slot>
      </p>

      <slot></slot>
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na ULIC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      streets: [],
      search: '',
      showSelect: false,
      selectedUlic: '',
      error: ''
    };
  },
  methods: {
    // @vuese
    // Sprawdza czy lista ulic nie jest pusta
    checkULICList() {
      if (this.terc && this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&count=1`)
          .then(res => {
            if (res.data.list.length === 0) {
              this.showSelect = false;
            } else {
              this.showSelect = true;
            }
          })
          .catch(error => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Przeszukuje listę ulic
    searchULICList(val) {
      if (this.terc && this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&search=${val}`)
          .then(res => {
            this.streets = res.data.list;
            this.error = '';
          })
          .catch(error => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Zapisuje wybraną ulicę lub wyświetla komunikat o błędzie
    saveUlic() {
      if (this.selectedUlic) {
        const name = this.streets.find(item => item.symbol === this.selectedUlic).nameFull;
        // Emituje event do zapisu wartości ULIC
        // @arg Obiekt z wartością ULIC i nazwą ulicy
        this.$emit('saveUlic', { ulic: this.selectedUlic, name });
        this.streets = [];
        this.selectedUlic = '';
      } else {
        this.error = 'Proszę wpisać nazwę ulicy przed dodaniem';
      }
    }
  },
  watch: {
    simc(newValue) {
      this.streets = [];
      this.model.$setData({
        streets: '',
        ulic: ''
      });
      this.checkULICList();
    },
    search(val) {
      if (val) {
        this.searchULICList(val);
      }
    }
  },
  beforeMount() {
    this.checkULICList();
  }
};
</script>

<style scoped>
.autocomplete-warning {
  color: red;
  margin-top: -20px;
}
</style>
